import { render, staticRenderFns } from "./opportunite.vue?vue&type=template&id=26fb1f4f&"
import script from "./opportunite.vue?vue&type=script&lang=js&"
export * from "./opportunite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports